import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { registerSubdomain } from 'src/utils/contracts/registry';
import useStore from 'src/store/cns';
import { insertNode } from 'src/utils/data/domains';
import { ethers } from 'ethers';
import { handleError } from 'src/utils/errors/common';
import Table from './Table';
import Search from './Search';

const ShowSubdomains: React.FC<{
  selectDomain: (domain: Domain | undefined) => void;
  selectedDomain: Domain;
}> = ({ selectedDomain, selectDomain }) => {
  const wallet = useStore(state => state.wallet);

  const parent: string = selectedDomain.name;
  const [filteredDomains, setFilteredDomains] = useState<Domain[]>(
    selectedDomain.subdomains,
  );
  const [searchQuery, setSearchQuery] = useState('');

  const handleSubdomainRegistration = async () => {
    const resolverAddress = selectedDomain?.resolver
      ? selectedDomain.resolver.resolverAddress
      : '';

    try {
      await registerSubdomain(parent.split('.'), searchQuery, resolverAddress);
      if (wallet) {
        const mirrorDomain = selectedDomain;
        mirrorDomain.subdomains.push({
          name: searchQuery + '.' + parent,
          accessRights: 'owner',
          subdomains: [],
          managers: [],
        });

        insertNode({
          name: searchQuery + '.' + parent,
          owner: wallet?.address,
          parentHash: ethers.namehash(parent),
          hash: ethers.namehash(searchQuery + '.' + parent),
          subdomains: [],
        });
        selectDomain(mirrorDomain);
      }
      setSearchQuery('');
    } catch (error) {
      handleError(error, `Failed to register ${searchQuery}.`);
    }
  };

  useEffect(() => {
    setFilteredDomains(selectedDomain.subdomains);
  }, [selectedDomain]);

  return (
    <Box>
      <Search
        setFilteredDomains={setFilteredDomains}
        updateSearchQuery={setSearchQuery}
        selectDomain={selectDomain}
        register={handleSubdomainRegistration}
        domains={selectedDomain.subdomains}
        searchQuery={searchQuery}
      />
      <Table
        domains={filteredDomains}
        searchQuery={searchQuery}
        parentDomain={parent}
        selectDomain={selectDomain}
      />
    </Box>
  );
};

export default React.memo(ShowSubdomains);
